export const MFM_ALLOWED_TAGS = new Set([
  'tada',
  'jelly',
  'twitch',
  'shake',
  'spin',
  'jump',
  'bounce',
  'flip',
  'x2',
  'x3',
  'x4',
  'scale',
  'position',
  'fg',
  'bg',
  'border',
  'font',
  'blur',
  'rainbow',
  'sparkle',
  'rotate',
  'ruby',
  'unixtime',
]);

export const MFM_PHOTOSENSITIVE_TAGS = new Set([
  'tada',
  'jelly',
  'twitch',
  'shake',
  'spin',
  'jump',
  'bounce',
  'rainbow',
  'sparkle',
]);

export const MFM_TRANSFORM_TAGS = new Set(['x3', 'x4', 'scale', 'position']);

export const MFM_SENSITIVE_FOLD_TAGS = new Set([
  'tada',
  'jelly',
  'twitch',
  'shake',
  'spin',
  'jump',
  'bounce',
  'rainbow',
  'sparkle',
  'x2',
  'x3',
  'x4',
  'scale',
  'border',
]);

export const MFM_PROFILE_ALLOWED_TAGS = new Set([
  'fg',
  'bg',
  'border',
  'font',
  'ruby',
  'unixtime',
]);

export const MFM_ALLOWED_FONTS = new Set([
  'serif',
  'monospace',
  'cursive',
  'fantasy',
  'emoji',
  'math',
]);

export const MFM_ALLOWED_BORDER_STYLES = new Set([
  'hidden',
  'dotted',
  'dashed',
  'solid',
  'double',
  'groove',
  'ridge',
  'inset',
  'outset',
]);

export const MFM_MAX_SCALE = 5;

export const MFM_FOLD_LENGTH_THRESHOLD = 1000;
